import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { FeaturesService } from '../services/features.service';

export const labsModeGuard: CanActivateFn = () => {
  const features = inject(FeaturesService);
  const router = inject(Router);
  return features.labsMode() ? true : router.createUrlTree(['/']);
};
